import { render } from "./WalletExchangeBreakdownSummary.vue?vue&type=template&id=6d948e46&scoped=true"
import script from "./WalletExchangeBreakdownSummary.vue?vue&type=script&lang=js"
export * from "./WalletExchangeBreakdownSummary.vue?vue&type=script&lang=js"

import "./WalletExchangeBreakdownSummary.vue?vue&type=style&index=0&id=6d948e46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d948e46"]])

export default __exports__